module.exports = __webpack_public_path__ + "static/media/Super Gussun Oyoyo 2.24f13380.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/about/Super Gussun Oyoyo 2.png
// module id = 246
// module chunks = 0